import { VStack } from '@genial/components';
import React from 'react';

import {
  OrderCycleMode,
  TableHeadContainer,
  TableHeadItem,
  TableHeadItemRecurse,
} from '../../../../components/TableHead';
import { useSortHandler } from '../../../../components/TableHead/utils';
import { customersTableHead } from '../../constants';

interface TableHeadProps {
  onSortingChanged: () => void;
  orderCycleMode?: OrderCycleMode;
}

export const TableHead: React.FC<TableHeadProps> = ({
  onSortingChanged,
  orderCycleMode = 'partial',
}) => {
  const [handleSortHandler, orderBy] = useSortHandler('customers', orderCycleMode);

  const handleSort = (item: TableHeadItemRecurse) => {
    if (!item.orderValue) {
      return;
    }

    onSortingChanged?.();
    return handleSortHandler(item);
  };

  return (
    <VStack space="inline.nano" px="inline.xxxs" mb="stack.nano">
      <TableHeadContainer px="inline.xxxs">
        {customersTableHead.map((item, index) => {
          return (
            <TableHeadItem
              onPress={() => handleSort(item)}
              key={`${item.title}-${index}`}
              title={item.title}
              orderBy={orderBy}
              flex={item.flex}
              value={item.orderValue}
            />
          );
        })}
      </TableHeadContainer>
    </VStack>
  );
};
